import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const createDDN = async (data) => {
  try {
    return await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/document-delivery-note`,
      data,
    );
  } catch (e) {
    console.error(e);
  }
};

export const searchDDN = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/document-delivery-note/search`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getDDNById = async (id) => {
  try {
    return await gatewayInstance.get(
      `${SERVICE_ENDPOINT.REPORT}/document-delivery-note/${id}`,
    );
  } catch (error) {
    console.error(error);
  }
};

export const updateDDNByID = async (id, data) => {
  try {
    return await gatewayInstance.put(
      `${SERVICE_ENDPOINT.REPORT}/document-delivery-note/${id}`,
      data,
    );
  } catch (error) {
    console.error(error);
  }
};

export const generateDDNSearch = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/document-delivery-note/generate-search`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Download Inspection Document API
 * @param {Object} payload - The data to be sent in the API request
 * @param {string} reportType - The type of report to generate (e.g., "pdf")
 * @returns {Promise<Blob>} - A Blob containing the generated report
 */
export const downloadDocumentDeliveryNote = async (
  payload,
  reportType = "pdf",
) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/document-delivery-note/generate/report?reportType=${reportType}`,
      payload,
      { responseType: "blob" }, // To handle binary PDF file responses
    );

    return response.data; // Return the Blob directly
  } catch (error) {
    console.error("Error downloading inspection document:", error);
    throw error;
  }
};

export const generateAndSendEmail = async (id, data) => {
  try {
    return await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/document-delivery-note/generate-and-send-email/${id}`,
      data,
    );
  } catch (error) {
    console.error(error);
  }
};
